import React, { useEffect, useRef, useState } from "react";
import { FaArrowUp } from "react-icons/fa";

const UpToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const scrollToTopBtnRef = useRef(null);

  useEffect(() => {
    const scrollFunction = () => {
      if (
        document.body.scrollTop > 150 ||
        document.documentElement.scrollTop > 150
      ) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", scrollFunction);

    return () => {
      window.removeEventListener("scroll", scrollFunction);
    };
  }, []);

  const backToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      type="button"
      ref={scrollToTopBtnRef}
      data-twe-ripple-init
      data-twe-ripple-color="light"
      aria-label="Volver arriba"
      className={`bg-[#1582C7] fixed bottom-3 right-5 rounded-full z-20 w-12 h-12 flex items-center justify-center
        text-white shadow-md transition duration-150 
        ease-in-out hover:cursor-pointer hover:shadow-xl hover:bg-[#1065a0] focus:shadow-lg 
        focus:outline-none focus:ring-0 focus:bg-[#1065a0] active:bg-[#1065a0] active:shadow-lg
        ${isVisible ? "opacity-100" : "opacity-0"}
        `}
      onClick={backToTop}
    >
      <FaArrowUp className="h-4 w-4 text-white sm:w-6 sm:h-6" />
    </button>
  );
};

export default UpToTopButton;
